import { render } from "./Reopen.vue?vue&type=template&id=6fc04d86"
import script from "./Reopen.vue?vue&type=script&lang=js"
export * from "./Reopen.vue?vue&type=script&lang=js"
script.render = render

export default script